"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditButton = exports.DescriptionWrapper = exports.Container = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _carrot = _interopRequireDefault(require("../../../assets/svg/carrot.svg"));
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Container = _styledComponents.default.div.attrs({
  role: 'button'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 120px;\n  font-family: 'Brandon Grotesque', Arial, sans-serif;\n  font-weight: 800;\n  font-style: normal;\n  font-size: 24px;\n  line-height: 110%;\n  display: flex;\n  justify-content: center;\n  padding: 0 52px;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: #ffffff;\n  border-radius: 0 0 0 70px;\n  position: relative;\n  flex-direction: column;\n  cursor: pointer;\n\n  &.open {\n    &:after {\n      background-color: #fff !important;\n    }\n  }\n\n  span {\n    display: block;\n    font-size: 14px;\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 70px;\n    height: 70px;\n    border-radius: 0;\n    z-index: -1;\n  }\n\n  &::before {\n    background-image: url(", ");\n    background-repeat: no-repeat;\n    background-position: right 25px center;\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 5;\n  }\n\n  &.school {\n    background-color: #2f1747;\n    &::after {\n      background-color: #a098ed;\n      background-position: right 25px center;\n    }\n    &::before {\n      background-position: right 25px center;\n    }\n  }\n\n  &.whyCompany {\n    height: 120px;\n    background-color: #53b7c2;\n    &::after {\n      background-color: ", ";\n    }\n  }\n\n  &.skill {\n    height: 120px;\n    background-color: #85317f;\n    &::after {\n      background-color: ", ";\n    }\n  }\n\n  &.diversity-inclusion {\n    height: 120px;\n    background-color: #e971e3;\n    &::after {\n      background-color: ", ";\n    }\n  }\n\n  &.experience {\n    height: 120px;\n    background-color: #a39df7;\n    &::after {\n      background-color: ", ";\n    }\n  }\n\n  &.writing {\n    height: 120px;\n    background-color: #8e94b5;\n    &::after {\n      background-color: ", ";\n    }\n  }\n\n  &.preferences {\n    height: 120px;\n    background-color: #53b7c2;\n  }\n"])), _carrot.default, function (_ref) {
  var viewDiversities = _ref.viewDiversities,
    viewWritingSection = _ref.viewWritingSection,
    viewSkills = _ref.viewSkills;
  if (viewSkills) {
    return '#85317f';
  }
  if (viewDiversities) {
    return '#e971e3';
  }
  if (viewWritingSection) {
    return '#8e94b5';
  }
  return 'transparent';
}, function (_ref2) {
  var viewDiversities = _ref2.viewDiversities,
    viewWritingSection = _ref2.viewWritingSection;
  if (viewDiversities) {
    return '#e971e3';
  }
  if (viewWritingSection) {
    return '#8e94b5';
  }
  return 'transparent';
}, function (_ref3) {
  var viewWritingSection = _ref3.viewWritingSection;
  return viewWritingSection ? '#8e94b5' : 'transparent';
}, function (_ref4) {
  var viewDiversities = _ref4.viewDiversities,
    viewWritingSection = _ref4.viewWritingSection,
    viewSkills = _ref4.viewSkills,
    viewWhyCompany = _ref4.viewWhyCompany;
  if (viewWhyCompany) {
    return '#53b7c2';
  }
  if (viewSkills) {
    return '#85317f';
  }
  if (viewDiversities) {
    return '#e971e3';
  }
  if (viewWritingSection) {
    return '#8e94b5';
  }
  return 'transparent';
}, function (_ref5) {
  var showPrivate = _ref5.showPrivate;
  return showPrivate ? '#53b7c2' : 'transparent';
});
exports.Container = Container;
var DescriptionWrapper = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
exports.DescriptionWrapper = DescriptionWrapper;
var EditButton = _styledComponents.default.button(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  margin-left: 5px;\n  padding: 0;\n  z-index: 6;\n\n  &:active,\n  :focus {\n    outline: 0;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n  }\n"])));
exports.EditButton = EditButton;